<script setup lang="ts">
import type { StaffDuplicateFileDto } from '@roadfootage/api-client'
import { formatDateTime } from '@/utils/format'

// Staff only: files elsewhere with the same checksum. Never shows who uploaded them, only whether it is the same uploader.
defineProps<{ duplicates: StaffDuplicateFileDto[] }>()
</script>

<template>
  <div v-if="duplicates.length" class="q-mt-xs" data-testid="duplicate-files">
    <q-badge
      color="warning"
      text-color="black"
      icon="mdi-content-copy"
      label="Duplicate file"
      data-testid="duplicate-chip"
    />
    <div
      v-for="d in duplicates"
      :key="d.fileId"
      class="text-caption text-grey-8 q-mt-xs"
      data-testid="duplicate-row"
    >
      {{ d.sameUploader ? 'Same uploader' : 'Another uploader' }} · {{ d.reportModerationStatus }} ·
      {{ formatDateTime(d.uploadedAt) }}
      <router-link
        :to="{ name: 'incident-reports', query: { id: d.incidentReportId } }"
        @click.stop
      >
        Open report
      </router-link>
    </div>
  </div>
</template>
